var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVisa = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 16,
    viewBox: "0 0 49 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3219 5.2052C25.2946 7.36436 27.2405 8.56928 28.7063 9.28568C30.2123 10.0208 30.7182 10.4922 30.7124 11.1494C30.7009 12.1555 29.511 12.5994 28.3973 12.6166C26.4543 12.6469 25.3248 12.0906 24.4266 11.6697L23.7268 14.9545C24.6279 15.3711 26.2963 15.7344 28.0266 15.7502C32.0877 15.7502 34.7448 13.7395 34.7592 10.6219C34.775 6.66536 29.3027 6.44624 29.34 4.67768C29.3529 4.14152 29.8631 3.56924 30.9812 3.42368C31.5344 3.35024 33.062 3.29396 34.7937 4.09388L35.4734 0.915798C34.5422 0.575598 33.3451 0.249798 31.8549 0.249798C28.0323 0.249798 25.3436 2.28788 25.3219 5.2052ZM42.0049 0.523639C41.2634 0.523639 40.6382 0.957559 40.3595 1.62344L34.558 15.5167H38.6163L39.4239 13.2782H44.3832L44.8517 15.5167H48.4286L45.3072 0.523639H42.0049ZM42.5725 4.57388L43.7437 10.2038H40.5362L42.5725 4.57388ZM20.4015 0.523639L17.2026 15.5167H21.0697L24.2672 0.523639H20.4015ZM14.6805 0.523639L10.6553 10.7284L9.02705 2.05148C8.83598 1.08296 8.08151 0.523639 7.24365 0.523639H0.663416L0.571411 0.958998C1.9223 1.253 3.45708 1.72724 4.38682 2.2346C4.95584 2.54444 5.11832 2.8154 5.30508 3.55196L8.38899 15.5167H12.4761L18.7417 0.523639H14.6805Z",
    fill: "#1A1F71"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVisa, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/visa.1963e044.svg";
export { ForwardRef as ReactComponent };